import * as moment from 'moment';

export class DateFormattingUtils {
    static getDateFormatSettings(): any {
        let delimiters = ['.', '.', '/', ' ']
        let formats = delimiters.map(d => 'DD' + d + 'MM' + d + 'YYYY').concat(
                      delimiters.map(d => 'DD' + d + 'MMM' + d + 'YYYY'));
        return {
            parse: { dateInput: formats },
            display: {
                dateInput: 'inforser',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM YYYY',
            }
        }
    }

    static setupMomentParser() {
        let _moment = moment;
        if (_moment) {
            _moment.parseTwoDigitYear = function(yearString: string) {
                let parsedYear = parseInt(yearString);
                let currentYear = new Date().getFullYear() % 100;
                let century = parsedYear > currentYear ? 1900 : 2000;
                return century + parsedYear;
            }
        }
    }
}
